<template>
    <div class="h-100">
        <b-row align-h="center">
            <b-col cols="12" md="10">
                <b-link :to="{ name: 'settings-smartrouting' }"
                    ><font-awesome-icon icon="arrow-left" />
                    {{ $t("Back") }}
                </b-link>
                <h1 class="mt-1">
                    {{ $t("settings.title") }} / {{ $t("settings.smart-routing.title") }} /
                    {{ $t("settings.smart-routing.add.title") }}
                </h1>

                <hr />

                <div v-if="isLoading" class="d-flex justify-content-center mb-3">
                    <b-spinner />
                </div>

                <validation-observer v-if="!isLoading" ref="validationObserver" tag="form">
                    <app-basic-info />
                    <hr />
                    <app-channel />
                    <hr />
                    <app-contact-data />
                    <hr />
                    <app-templates />
                    <hr />
                    <app-keywords />
                    <hr />
                    <app-assignables />
                    <hr />
                    <contact-list />
                    <hr />
                    <app-business-hours />

                    <b-form-group content-cols-lg="7" content-cols-sm label-cols-lg="3" label-cols-sm="4">
                        <b-button
                            :disabled="isSaving"
                            class="d-flex justify-content-center mb-2"
                            variant="primary"
                            @click="addRoute"
                        >
                            <b-spinner v-if="isSaving" class="mr-50" small></b-spinner>
                            {{ $t("settings.smart-routing.add.submit") }}
                        </b-button>
                    </b-form-group>
                </validation-observer>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { BContainer, BRow, BCol, BLink, BButton, BFormGroup, BSpinner } from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import AppBasicInfo from "./components/basicInfo";
import AppChannel from "./components/channel";
import AppBusinessHours from "./components/businessHours";
import AppContactData from "./components/contactData";
import AppKeywords from "./components/keywords";
import AppAssignables from "./components/assignables";
import AppTemplates from "./components/templates";
import useRoutes from "./useRoutes";
import { useToast } from "vue-toastification/composition";
import i18n from "@/libs/i18n";
import useChannels from "@/composables/v2.1/useChannels";
import ContactList from "@/views/modules/settings/smart-routing/components/contactList.vue";

export default {
    components: {
        ContactList,
        BContainer,
        BRow,
        BCol,
        BLink,
        BButton,
        BFormGroup,
        BSpinner,
        AppAssignables,
        AppBasicInfo,
        AppChannel,
        AppContactData,
        AppBusinessHours,
        AppKeywords,
        AppTemplates,
        ValidationObserver,
    },
    setup() {
        const toast = useToast();
        const { parseRouteForSave, currentRoute, setCurrentRoute, saveCurrentRoute, isLoading, isSaving } = useRoutes();
        const { fetchChannels } = useChannels();
        isLoading.value = false;

        setCurrentRoute({
            contactDetailsMatchMode: "OR",
            contactDetailsToMatch: "{}",
            keywordMode: "OR",
            amountOfMessages: "1",
            userId: null,
            teamId: null,
            keywordStrings: [],
            identities: [],
            tags: [],
            labels: [],
            contactLists: [],
            contactListsToRemoves: [],
            templates: [],
            channelIds: [],
            settings: [],
        });
        fetchChannels({ params: { join: ["userChannels", "teamChannels"] } });

        return {
            currentRoute,
            toast,
            isSaving,
            isLoading,
            parseRouteForSave,
            saveCurrentRoute,
        };
    },
    methods: {
        addRoute() {
            return new Promise((resolve, reject) => {
                return this.$refs.validationObserver.validate().then((success) => {
                    if (success) {
                        try {
                            this.parseRouteForSave();
                        } catch (error) {
                            let translationKey = "settings.smart-routing.edit.error";
                            switch (error.message) {
                                case "Incomplete record":
                                    translationKey = "settings.smart-routing.contact-data.missing-input";
                                    break;
                                case "Invalid identity format":
                                    translationKey = "settings.smart-routing.identities.invalid-format";
                                    break;
                                case "Invalid template":
                                    translationKey = "settings.smart-routing.templates.errors.invalid-template";
                                    break;
                            }

                            this.toast.error(i18n.t(translationKey));
                            return reject();
                        }

                        return this.saveCurrentRoute()
                            .then(() => {
                                this.toast.success(i18n.t("settings.smart-routing.add.success"));
                                this.$router.push({ name: "settings-smartrouting" });
                                resolve();
                            })
                            .catch(() => {
                                this.toast.error(i18n.t("settings.smart-routing.add.error"));
                                reject();
                            });
                    } else {
                        this.toast.error(i18n.t("settings.smart-routing.add.error"));
                        reject();
                    }
                });
            }).catch(() => {});
        },
    },
};
</script>
